"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var experimentSetIndentation_1 = require("../experiment/experimentSetIndentation");
var processList_1 = require("../utils/processList");
/**
 * Set indentation at selection
 * If selection contains bullet/numbering list, increase/decrease indentation will
 * increase/decrease the list level by one.
 * @param editor The editor instance
 * @param indentation The indentation option:
 * Indentation.Increase to increase indentation or Indentation.Decrease to decrease indentation
 */
function setIndentation(editor, indentation) {
    if (editor.useExperimentFeatures()) {
        experimentSetIndentation_1.default(editor, indentation);
    }
    else {
        var command_1 = indentation == 0 /* Increase */ ? "indent" /* Indent */ : "outdent" /* Outdent */;
        editor.addUndoSnapshot(function () {
            editor.focus();
            var listNode = editor.getElementAtCursor('OL,UL');
            var newNode;
            if (listNode) {
                // There is already list node, setIndentation() will increase/decrease the list level,
                // so we need to process the list when change indentation
                newNode = processList_1.default(editor, command_1);
            }
            else {
                // No existing list node, browser will create <Blockquote> node for indentation.
                // We need to set top and bottom margin to 0 to avoid unnecessary spaces
                editor.getDocument().execCommand(command_1, false, null);
                editor.queryElements('BLOCKQUOTE', 1 /* OnSelection */, function (node) {
                    newNode = newNode || node;
                    node.style.marginTop = '0px';
                    node.style.marginBottom = '0px';
                });
            }
            return newNode;
        }, "Format" /* Format */);
    }
}
exports.default = setIndentation;
//# sourceMappingURL=setIndentation.js.map